export const FINANCING_ENDING_PREFLIGHT_BLOCK_REASON = {
  OVER_LIMIT: 'OVER_LIMIT',
  NONE_ELIGIBLE: 'NONE_ELIGIBLE',
} as const;
